import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const AquariusShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Horoscope" fill={fillColor}>
        <g>
          <path d="M42,27a2,2,0,0,0-2,2v2a4,4,0,0,1-8,0V29a2,2,0,0,0-4,0v2a4,4,0,0,1-8,0V29a2,2,0,0,0-4,0v2a4,4,0,0,1-8,0V29a2,2,0,0,0-4,0v2a8,8,0,0,0,8,8,8.2,8.2,0,0,0,6-2.7,8,8,0,0,0,12,0A8.2,8.2,0,0,0,36,39a8,8,0,0,0,8-8V29A2,2,0,0,0,42,27Z" />
          <path d="M42,9a2,2,0,0,0-2,2v2a4,4,0,0,1-8,0V11a2,2,0,0,0-4,0v2a4,4,0,0,1-8,0V11a2,2,0,0,0-4,0v2a4,4,0,0,1-8,0V11a2,2,0,0,0-4,0v2a8,8,0,0,0,8,8,8.2,8.2,0,0,0,6-2.7,8,8,0,0,0,12,0A8.2,8.2,0,0,0,36,21a8,8,0,0,0,8-8V11A2,2,0,0,0,42,9Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default AquariusShape;
